import { PaymentMethod } from '@stripe/stripe-js'
import { PaymentMethodPresentationMode } from '@dtx-company/app/shared/common/src/components/PlanPurchaseExperience/components/PaymentMethodDisplay'

export const getDefaultPaymentMethodAdditionalText = (
  paymentMethod: PaymentMethod,
  mode: PaymentMethodPresentationMode
): string => {
  if (paymentMethod.type === 'card' && paymentMethod.card) {
    return getCardDefaultPaymentMethodAdditionalText(paymentMethod, mode)
  } else if (paymentMethod.type === 'us_bank_account' && paymentMethod.us_bank_account) {
    return getAchDefaultPaymentMethodAdditionalText(paymentMethod.us_bank_account, mode)
  } else if (paymentMethod.type === 'ideal' && paymentMethod.ideal) {
    return getIdealDefaultPaymentMethodAdditionalText(paymentMethod.ideal, mode)
  } else {
    return ''
  }
}

export const getAchDefaultPaymentMethodAdditionalText = (
  account: PaymentMethod['us_bank_account'],
  mode: PaymentMethodPresentationMode
): string => {
  return mode === 'fullDescription' ? `${account?.account_type} ...${account?.last4}` : ''
}

export const getIdealDefaultPaymentMethodAdditionalText = (
  account: PaymentMethod['ideal'],
  mode: PaymentMethodPresentationMode
): string => {
  return mode === 'fullDescription' ? account?.bank || '' : ''
}

export const getCardDefaultPaymentMethodAdditionalText = (
  paymentMethod: PaymentMethod,
  mode: PaymentMethodPresentationMode
): string => {
  return mode === 'fullDescription'
    ? `Expires ${paymentMethod.card?.exp_month
        .toString()
        .padStart(2, '0')}/${paymentMethod.card?.exp_year.toString().slice(-2)}${
        paymentMethod.billing_details?.name ? `\n ${paymentMethod.billing_details?.name}` : ''
      }`
    : ''
}
